import { minifyGraphQL } from '@/lib/helper/minifyGraphql';

export const breakingNewRecordsFragment = minifyGraphQL(`docs{
id
timestamp
title
description
twitterId
content{
title
description
slug
type
subType
readingTime{
text
}
}
}`);
